












































































import { Component, Vue } from 'vue-property-decorator'
import { ErrorLogStoreModule as errorLogStore } from '@/shared/config/store/error-log-store'

@Component({
  name: 'ErrorLog'
})
export default class extends Vue {
  private dialogTableVisible = false

  get errorLogs() {
    return errorLogStore.logs
  }

  private clearAll() {
    this.dialogTableVisible = false
    errorLogStore.clear()
  }
}
